import React, { useEffect, useState } from 'react'
import Swal from 'sweetalert2';
import { myApi } from '../../../config/axiosConfig';
import { PDFDownloadLink } from '@react-pdf/renderer';
import { Typography, Grid2, Button, Box, Chip } from '@mui/material';

// ICONOS
import HourglassEmptyIcon from '@mui/icons-material/HourglassEmpty';
import QrCodeIcon from '@mui/icons-material/QrCode';
import SyncIcon from '@mui/icons-material/Sync';
import TaskAltIcon from '@mui/icons-material/TaskAlt';
import CancelIcon from '@mui/icons-material/Cancel';

// COMPONENTES
import MiTabla from '../../../components/plantilla/tabla/MiTabla';
import EditarCaja from './modales/EditarCaja';
import QrDoc from './pdf/QrDoc';

const Cajas = () => {

    // ===========================================
    // FUNCION PARA BUSCAR TRACTORES
    // ===========================================

    const [cajas, setCajas] = useState([]);
    const [cajasActivas, setCajasActivas] = useState([]);

    const buscarCajas = async () => {

        try {

            const response = await myApi.get('/cajas/catalogo');

            setCajas(response.data);

            const cajasFiltradas = response.data.filter( obj => obj.mcleod_status == 'A')

            setCajasActivas(cajasFiltradas)

        } catch(error) {

            console.log(error);
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: 'Hubo un error al buscar los tractores.'
            });

        }

    }

    const catalogoChips = {

        "A": <Chip label={'Activo'} color="success"/>,
        "I": <Chip label={'Inactivo'} color="error"/>,
        "S": <Chip label={'En Taller'} color="warning"/>,

    }

    // ===========================================
    // COLUMNAS PARA TABLA
    // ===========================================

    const columns = [

        {
            field: 'caja', 
            headerName: 'Caja',
            flex: 1,
            headerAlign: "center",
            align: "center",
        },
        {
            field: 'mcleod_status', 
            headerName: 'Status',
            flex: 1,
            headerAlign: "center",
            align: "center",
            renderCell: (params) => catalogoChips[params.value],
        },
        {
            field: 'fleet', 
            headerName: 'Fleet',
            flex: 1,
            headerAlign: "center",
            align: "center",
        },
        { 
            field: 'placas', 
            headerName: 'Placas USA',
            flex: 1,
            headerAlign: "center",
            align: "center",
        },
        { 
            field: 'placas_estado', 
            headerName: 'Placas Estado',
            flex: 1,
            headerAlign: "center",
            align: "center",
        },
        { 
            field: 'mcleod_id', 
            headerName: 'Mcleod',
            flex: 1,
            headerAlign: "center",
            align: "center",
            renderCell: (params) => params.row.mcleod_id !== '--'? <TaskAltIcon /> : <CancelIcon />,
        },
        { 
            field: 'samsara_truck_id', 
            headerName: 'Samsara',
            flex: 1,
            headerAlign: "center",
            align: "center",
            renderCell: (params) => params.row.gps !== '--'? <TaskAltIcon /> : <CancelIcon />,
        },

    ];

    // ===========================================
    // FUNCION PARA ACTUALIZAR DATOS DE CAJAS
    // ===========================================

    const handleUpdateCajas = async () => {

        Swal.fire({
            title: 'Sincronizando Datos...',
            text: 'Por favor, espera...',
            allowOutsideClick: false,
            didOpen: () => {
                Swal.showLoading();
            }
        });
    
        try {

            const response = await myApi.get('cajas/actualizar_cajas');

            if(response.data.success){

                buscarCajas();

                // Cuando finaliza, mostrar un mensaje de éxito
                Swal.fire({
                    icon: 'success',
                    title: '¡Datos Sincronizados!',
                    timer: 2000,
                    showConfirmButton: false
                });

            }
    
        } catch (error) {

            // Si ocurre un error, mostrar un mensaje de error
            console.log(error);

        }

    }

    // ===========================================
    // ESTADO PARA MODAL
    // ===========================================

    const [showModal, setShowModal] = useState(false);
    const [formValues, setFormValues] = useState({});

    const handleRowClick = (params) => {

        setFormValues(params.row)
        setShowModal(true)

    }

    // ===========================================
    // USE EFFECT PARA LLAMAR DATOS
    // ===========================================

    useEffect(() => {

        buscarCajas();

    }, []);

    // ===========================================

    return (

        <Grid2 container>

            {/* HEADER */}

            <Grid2 
                size={12}
                sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                }}
            >

                <Typography
                    variant="h4"
                    fontWeight={700}
                >
                    Catalogo Cajas
                </Typography>

                <Box>

                    {/* BOTON PARA ACTUALIZAR DATOS */}

                    {/* <Button
                        variant="contained" 
                        color="secondary"
                        loadingPosition="start"
                        loading={false}
                        startIcon={<SyncIcon/>}
                        sx={{ marginRight: 2 }}
                        onClick={handleUpdateCajas}
                    >
                        Actualizar Datos
                    </Button> */}

                    {/* BOTON PARA DESCARGAR QR */}

                    {/* <PDFDownloadLink 
                        document={<QrDoc cajas={cajasActivas} />} 
                        fileName="QR_Cajas.pdf"
                    >
                        {({ loading }) => (
                            <Button 
                                variant="contained" 
                                color="primary" 
                                disabled={loading}
                                startIcon={loading ? <HourglassEmptyIcon /> : <QrCodeIcon />}
                            >
                                {loading ? "Generando PDF..." : "Descargar QR"}
                            </Button>
                        )}
                    </PDFDownloadLink> */}

                </Box>

            </Grid2>

            {/* TABLA */}

            <Grid2 size={12} marginTop={2}>

                <MiTabla
                    data={cajas}
                    columns={columns}
                    rowClick={handleRowClick}
                />

            </Grid2>

            {/* MODAL EDITAR */}

            <EditarCaja
                open={showModal}
                onClose={() => setShowModal(false)}
                refresh={buscarCajas}
                data={formValues}
            />

        </Grid2>

    )

}

export default Cajas